/**
 * Canonical level ids for per-level play stats and completion flags.
 * Extend this union (and GAME_LEVEL_IDS) when adding new scenes / chapters.
 */
export type GameLevelId = 'tutorial' | 'dummy' | 'mainGame';

/** Single source of truth for iteration and migration (keep in sync with GameLevelId). */
export const GAME_LEVEL_IDS = ['tutorial', 'dummy', 'mainGame'] as const satisfies readonly GameLevelId[];

export function isGameLevelId(value: string): value is GameLevelId {
  return (GAME_LEVEL_IDS as readonly string[]).includes(value);
}

/**
 * Map Excalibur scene / GlobalGameStore `currentLevel` string to a stats bucket.
 * Unknown future scene names roll into `mainGame` so saves keep working.
 */
export function sceneNameToGameLevelId(sceneName: string): GameLevelId {
  if (isGameLevelId(sceneName)) {
    return sceneName;
  }
  return 'mainGame';
}
